module.exports = __webpack_public_path__ + "static/img/icons8-physics.445b4226.svg";